/* tslint:disable */
/* eslint-disable */
/**
 * E.ON Home Dashboard - API
 * This API provides access and control function for smart equipped homes. For near real-time information please use this API here https://sse-hems-dev2.eon.ooo/docs/. `[NOTE]` The access token for the current user session is also valid for the real-time API utilising SSE (Server Sent Event)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: sebastian.eggers@eon.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  Forbidden,
  IotPairingModifyModel,
  NotFound,
  Unauthorized,
} from '../models';

export interface IoTAccountPairingV3SetPairVendorV3Request {
    iotPairingModifyModel: IotPairingModifyModel;
}

/**
 * 
 */
export class IoTAccountPairingV3Api extends runtime.BaseAPI {

    /**
     * For GridX EV: returns immediately after OAuth validation, deferring configuration creation to the register-vehicle Lambda (webhook-driven). For all other vendors: delegates to the synchronous V1 pairing logic.
     * Link a vendor account (V3)
     */
    async ioTAccountPairingV3SetPairVendorV3Raw(requestParameters: IoTAccountPairingV3SetPairVendorV3Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.iotPairingModifyModel === null || requestParameters.iotPairingModifyModel === undefined) {
            throw new runtime.RequiredError('iotPairingModifyModel','Required parameter requestParameters.iotPairingModifyModel was null or undefined when calling ioTAccountPairingV3SetPairVendorV3.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/smarthome/pairing:write"]);
        }

        const response = await this.request({
            path: `/api/v3/iot/pairing`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.iotPairingModifyModel,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * For GridX EV: returns immediately after OAuth validation, deferring configuration creation to the register-vehicle Lambda (webhook-driven). For all other vendors: delegates to the synchronous V1 pairing logic.
     * Link a vendor account (V3)
     */
    async ioTAccountPairingV3SetPairVendorV3(requestParameters: IoTAccountPairingV3SetPairVendorV3Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.ioTAccountPairingV3SetPairVendorV3Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
